import { z } from 'zod';
import { ArchSchema, FamilyChoiceSchema, FamilySourceSchema } from './families.js';
/** ComfyUI 0.38's own model folders (docs 13, 36). */
export const ModelFolderSchema = z.enum([
    'checkpoints', 'loras', 'vae', 'upscale_models', 'embeddings', 'controlnet', 'clip_vision', 'diffusion_models', 'text_encoders',
    'style_models', 'vae_approx', 'gligen', 'latent_upscale_models', 'hypernetworks', 'photomaker', 'model_patches', 'audio_encoders',
    'background_removal', 'frame_interpolation', 'geometry_estimation', 'optical_flow', 'detection',
]);
/** Any folder under ComfyUI's models/: its own, or one a custom node reads ("sams", "ultralytics/bbox"). */
export const ModelFolderNameSchema = z.string().regex(/^[A-Za-z0-9][A-Za-z0-9_.-]{0,59}(\/[A-Za-z0-9][A-Za-z0-9_.-]{0,59})?$/, 'A folder under ComfyUI\'s models directory, e.g. checkpoints or ultralytics/bbox').refine((f) => !f.includes('..'), 'A folder under ComfyUI\'s models directory');
export const ModelFileSchema = z.object({
    name: z.string().min(1).max(255),
    sizeBytes: z.number().int().min(0),
    modifiedAt: z.string().max(64),
    /** Agent ≥ 0.9.0 (doc 48): what the header's structure says, and the tag the file gives itself. Checked on the server. */
    arch: z.string().max(40).nullable().optional(),
    tag: z.string().max(100).nullable().optional(),
});
/** What a machine's agent reports for `list_models`. Untrusted: validated before use. */
export const MachineModelsSchema = z.object({
    folders: z.record(ModelFolderNameSchema, z.array(ModelFileSchema).max(5000)),
    freeDiskBytes: z.number().int().min(0),
    truncated: z.boolean(),
});
/** A model file with its family (doc 48): `families` is empty when Couch is not sure, ['any'] for upscalers and the like. */
export const InstalledModelFileSchema = ModelFileSchema.extend({
    arch: ArchSchema.nullable(),
    families: z.array(FamilyChoiceSchema),
    familySource: FamilySourceSchema.nullable(),
});
/** GET /api/v1/machines/:id/models. */
export const InstalledModelsSchema = z.object({
    folders: z.record(ModelFolderNameSchema, z.array(InstalledModelFileSchema)),
    freeDiskBytes: z.number().int().min(0),
    truncated: z.boolean(),
});
//# sourceMappingURL=models.js.map